import React, { useState } from 'react';
import { auth, db } from '../firebase'; // Import your Firebase configuration
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore'; // Import Firestore functions
import { useNavigate } from 'react-router-dom';
import './SignupPage.css'; // Import the CSS file for styling

const SignupPage = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [city, setCity] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [organizationRole, setOrganizationRole] = useState('');
  const [signupSuccess, setSignupSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      // Store user data in Firestore
      await setDoc(doc(db, 'users', user.uid), {
        firstName,
        lastName,
        companyName,
        email: user.email,
        phoneNumber,
        businessAddress,
        city,
        zipCode,
        organizationRole,
      });
      setSignupSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error("Error signing up:", error);
      if (error.code === 'auth/email-already-in-use') {
        setErrorMessage('The email address is already in use by another account.');
      } else if (error.code === 'auth/phone-number-already-exists') {
        setErrorMessage('The phone number is already in use by another account.');
      } else {
        setErrorMessage('An error occurred during signup. Please try again.');
      }
    }
  };

  return (
    <div className="auth-shell auth-shell-signup">
      <div className="auth-page-container auth-signup-page-container">
        <h1>Create An Account To Login And View Our Products!</h1>
        <div className="auth-page auth-signup-page">
          <div className="auth-card auth-signup-card">
            <h2 className='auth-card-title'>Signup</h2>
            {signupSuccess && <p className="success-message">Signup successful!</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <form onSubmit={handleSignup}>
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Company Name"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <input
                type="tel"
                placeholder="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Business Address"
                value={businessAddress}
                onChange={(e) => setBusinessAddress(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Zip Code"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Organization Role"
                value={organizationRole}
                onChange={(e) => setOrganizationRole(e.target.value)}
                required
              />
              <button type="submit">Signup</button>
              <p className='auth-alt-link'>Already Have An Account? Sign In <a href={`${process.env.PUBLIC_URL}/login`}>Here!</a>.</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;